import { useState } from "react";
import { Wrapper, Datagrid, DeleteActionIcon, Permission } from "components";

import { Typography, IconButton, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { endpoints } from "appConfigs";
import format from "date-fns/format";
import Form from "./Form";
import Filters from "./Filters";
import { useAppState } from "components/AppProvider/AppProvider";
import { useFetch } from "hooks";
import { NotificationManager } from "react-notifications";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  titleBar: {
    padding: "1rem 0 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  centered: {
    margin: "0 auto",
  },
  label: {
    color: "#ffffff",
  },
  status: {
    textTransform: "capitalize",
  },
}));

const Prescriptions = () => {
  const { authUser } = useAppState();
  const classes = useStyles();
  const [edit, setEdit] = useState(null);
  const [filters, setFilters] = useState({});
  const { remove, loading } = useFetch(endpoints.casefiles);
  return (
    <>
      <Wrapper padding={false}>
        <Grid container spacing={0} justify="center">
          <Grid item xs={10}>
            <Grid container spacing={1} direction="column" justify="center">
              <Grid item className={classes.titleBar}>
                <Typography variant="h5">
                  <FormattedMessage id="casefiles" defaultMessage="Casefiles" />
                </Typography>
                <Permission permission="add_casefile">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setEdit(true)}
                  >
                    <FormattedMessage
                      id="addCasefile"
                      defaultMessage="Add Casefile"
                    />
                  </Button>
                </Permission>
              </Grid>
              <Grid item>
                <Card>
                  <CardContent>
                    <Filters
                      filters={filters}
                      setFilters={setFilters}
                      authUser={authUser}
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item>
                <Datagrid
                  url={endpoints.casefiles}
                  filters={filters}
                  columns={[
                    ...(authUser.user_type === "admin"
                      ? [
                          {
                            headerName: (
                              <FormattedMessage
                                id="hospital"
                                defaultMessage="Hospital"
                              />
                            ),
                            field: "hospital.name",
                            renderCell: ({ row }) => row.hospital?.name,
                          },
                        ]
                      : []),
                    {
                      headerName: (
                        <FormattedMessage
                          id="createdAt"
                          defaultMessage="Created At"
                        />
                      ),
                      field: "createdAt",
                      renderCell: ({ row }) =>
                        format(new Date(row.createdAt), "dd MMM yyyy"),
                    },
                    {
                      headerName: (
                        <FormattedMessage
                          id="patient"
                          defaultMessage="Patient"
                        />
                      ),
                      field: "user.name",
                      renderCell: ({ row }) => row.user?.name,
                    },
                    {
                      headerName: (
                        <FormattedMessage id="doctor" defaultMessage="Doctor" />
                      ),
                      field: "doctor.name",
                      renderCell: ({ row }) => row.doctor?.name,
                    },
                    {
                      headerName: (
                        <FormattedMessage
                          id="appointments"
                          defaultMessage="Appointments"
                        />
                      ),
                      field: "appointments",
                      renderCell: ({ row }) => row.appointments.length,
                    },
                    {
                      headerName: (
                        <FormattedMessage
                          id="prescriptions"
                          defaultMessage="Prescriptions"
                        />
                      ),
                      field: "prescriptions",
                      renderCell: ({ row }) => row.prescriptions.length,
                    },
                    {
                      headerName: (
                        <FormattedMessage id="status" defaultMessage="Status" />
                      ),
                      field: "status",
                    },
                    {
                      headerName: (
                        <FormattedMessage id="action" defaultMessage="Action" />
                      ),
                      field: "action",
                      width: 120,
                      renderCell: ({ row }) => (
                        <>
                          <Permission permission="update_casefiles">
                            <IconButton
                              aria-label={
                                <FormattedMessage
                                  id="editPrescription"
                                  defaultMessage="Edit Prescription"
                                />
                              }
                              onClick={() => setEdit(row)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Permission>
                          <Permission permission="remove_casefiles">
                            <DeleteActionIcon
                              disabled={loading}
                              title={
                                <FormattedMessage
                                  id="deletePrescription"
                                  defaultMessage="Delete Prescription"
                                />
                              }
                              message={
                                <FormattedMessage
                                  id="deleteConfirmation_prescription"
                                  defaultMessage="Are you sure want to remove this prescription?"
                                />
                              }
                              deleteRecord={() => {
                                remove({ ids: row.id })
                                  .then(({ data }) => {
                                    if (data.success) {
                                      setFilters((prev) => ({ ...prev }));
                                    }
                                  })
                                  .catch((err) => {
                                    NotificationManager.error(err.message);
                                  });
                              }}
                            />
                          </Permission>
                        </>
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Form
          authUser={authUser}
          open={!!edit}
          edit={edit}
          setEdit={setEdit}
          onSuccess={(newSubPackage) => {
            setFilters((prev) => ({ ...prev }));
            setEdit(null);
          }}
        />
      </Wrapper>
    </>
  );
};

export default Prescriptions;
